import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { AvailabilityService } from '../../core/services/availability.service';
import {
  WeeklySchedule,
  DayOfWeek,
  DaySchedule,
  DAY_NAMES,
} from '../../core/models/schedule.model';

interface DayRow {
  day: DayOfWeek;
  name: string;
  enabled: boolean;
  from: string;
  to: string;
}

@Component({
  selector: 'app-availability',
  standalone: false,
  templateUrl: './availability.component.html',
  styleUrl: './availability.component.scss',
})
export class AvailabilityComponent implements OnInit, OnDestroy {
  rows: DayRow[] = [];
  saved = false;
  private sub = new Subscription();

  readonly timeOptions = this.buildTimeOptions();

  constructor(private availSvc: AvailabilityService) {}

  ngOnInit(): void {
    this.sub.add(
      this.availSvc.schedule$.subscribe(schedule => {
        this.rows = (Object.keys(schedule) as unknown as DayOfWeek[]).map(d => {
          const key = Number(d) as DayOfWeek;
          const s = schedule[key];
          return { day: key, name: DAY_NAMES[key], ...s };
        });
      })
    );
  }

  ngOnDestroy(): void { this.sub.unsubscribe(); }

  toggle(row: DayRow): void {
    row.enabled = !row.enabled;
  }

  saveAll(): void {
    const schedule: WeeklySchedule = {} as WeeklySchedule;
    for (const row of this.rows) {
      schedule[row.day] = { enabled: row.enabled, from: row.from, to: row.to };
    }
    this.availSvc.save(schedule);
    this.saved = true;
    setTimeout(() => (this.saved = false), 2500);
  }

  private buildTimeOptions(): string[] {
    const options: string[] = [];
    for (let h = 0; h < 24; h++) {
      for (const m of [0, 30]) {
        options.push(
          `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`
        );
      }
    }
    return options;
  }
}
